import { SecurityQuestionsBehaviours } from '../../../interfaces/SecurityQuestionsBehaviours';

export default function validateAnswer(questionNumber: number, selectedAnswers: string[], behaviours: SecurityQuestionsBehaviours): (value: string) => { [errorName: string]: boolean } {
  return (value: string): { [errorName: string]: boolean } => {
    if (!value) {
      return {};
    }
    if (value.length < behaviours.answerMinLength || value.length > behaviours.answerMaxLength) {
      if (!behaviours.regularExpression.test(value)) {
        return { lengthAndFormat: true };
      }
      return { length: true };
    }
    if (!behaviours.regularExpression.test(value)) {
      return { format: true };
    }
    for (let i = 0; i < questionNumber - 1; i++) {
      if (selectedAnswers[i].toUpperCase() === value.toUpperCase()) {
        return { unicity: true };
      }
    }
    return {};
  };
}
